import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaArrowLeft } from 'react-icons/fa';
import ClientSidebar from './ClientSidebar';
import { ClientSignoffStatsProvider } from './ClientSignoffStatsContext';
import talentLogo3 from '../assets/talentlogo3-removebg-preview.png';

const ClientRealLayout = ({ children }) => {
  const navigate = useNavigate();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  return (
    <ClientSignoffStatsProvider>
    <div className="min-h-screen bg-background flex flex-col md:flex-row">
      {/* Mobile Header */}
      <div className="md:hidden bg-sidebar-bg text-sidebar-text px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="p-1 hover:bg-sidebar-hover rounded">
            <FaArrowLeft className="w-4 h-4" />
          </button>
          <button onClick={() => setIsMobileSidebarOpen(true)} className="p-1 hover:bg-sidebar-hover rounded">
            <FaBars className="w-4 h-4" />
          </button>
          <h1 className="text-lg font-semibold">Client</h1>
        </div>
        <img src={talentLogo3} alt="Talent Logo" className="h-8 w-auto" />
      </div>

      {/* Mobile Sidebar Overlay */}
      {isMobileSidebarOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setIsMobileSidebarOpen(false)}></div>
          <div className="absolute left-0 top-0 h-full w-80 bg-sidebar-bg text-sidebar-text flex flex-col">
            <div className="p-4 flex items-center justify-between border-b border-sidebar-hover">
              <img src={talentLogo3} alt="Talent Logo" className="h-10 w-auto" />
              <button onClick={() => setIsMobileSidebarOpen(false)} className="p-1 hover:bg-sidebar-hover rounded">
                <FaTimes className="w-5 h-5" />
              </button>
            </div>
            <div className="flex-1 overflow-hidden">
              <ClientSidebar onLinkClick={() => setIsMobileSidebarOpen(false)} />
            </div>
          </div>
        </div>
      )}

      {/* Desktop Sidebar */}
      <div className="hidden md:flex w-[12rem] flex-shrink-0">
        <ClientSidebar />
      </div>

      <div className="flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden">
        {children}
      </div>
    </div>
    </ClientSignoffStatsProvider>
  );
};

export default ClientRealLayout;
